import { formatCurrency } from "../../utils/currencyFormatter";

export const formatDate = (dateStr) => {
  if (!dateStr) return "";
  const isoMatch = dateStr.match(/(\d{4})-(\d{2})-(\d{2})/);
  if (isoMatch) {
    return `${isoMatch[3]}-${isoMatch[2]}-${isoMatch[1]}`;
  }
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return dateStr;
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

export const parseCost = (costStr) => {
  if (!costStr || costStr === 'Free' || costStr === 'Included') return 0;
  const num = parseFloat(costStr.replace(/[^0-9.]/g, ''));
  return isNaN(num) ? 0 : num;
};

export const formatCost = (amount, currency = 'INR') => {
  return formatCurrency(amount, currency);
};

export const validateDayCost = (costStr, budget, totalDays) => {
  if (!costStr) return null;

  const cost = parseCost(costStr);
  if (cost === 0) return costStr;

  if (budget && totalDays) {
    const avgDailyBudget = budget / totalDays;
    if (cost > avgDailyBudget * 5) {
      const currency = costStr.match(/[₹$€£]|INR|USD|EUR|GBP/)?.[0] || 'INR';
      return formatCurrency(Math.round(avgDailyBudget * 1.2), currency);
    }
  }

  return costStr;
};
